import { render, staticRenderFns } from "./Create-Product.vue?vue&type=template&id=8fd978a8"
import script from "./Create-Product.vue?vue&type=script&lang=js"
export * from "./Create-Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports